import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { PageContainer } from '../../../../../components/page-container/page-container'
import { paths } from '../../../../../router/paths'
import { styles, texts } from './dashboard.styles'
import { Button } from '../../../../../components/button'
import type { RootState } from '../../../../../redux/global-store'
import { isJourneyActive } from '../../../../../utils/journey-utils'
import { showToast } from '../../../../../components/sonner'

export const Dashboard = () => {
  const navigate = useNavigate()
  const [hoveredButton, setHoveredButton] = useState<string | null>(null)
  const { journey } = useSelector((state: RootState) => state.journey.journey)

  const handleDailySales = () => {
    navigate(paths.dailySales)
  }

  const handlePreviousClosings = () => {
    navigate(paths.previousClosings)
  }

  const handleNewSale = () => {
    if (!isJourneyActive(journey)) {
      showToast('No hay jornada activa. Por favor inicia una jornada primero.', 'error')
      navigate(paths.journey.input)
      return
    }
    navigate(paths.collectionOrder.newSale)
  }

  // Função para verificar se o usuário está autenticado
  const isUserAuthenticated = () => {
    const token = localStorage.getItem('token')
    const logged = sessionStorage.getItem('logged') === 'true'
    return !!(token && logged)
  }

  // Validar se há jornada ativa - somente se o usuário estiver autenticado
  useEffect(() => {
    // Só verifica jornada se o usuário estiver autenticado
    if (!isUserAuthenticated()) {
      return // Se não está autenticado, não faz nada (ProtectedRouter vai redirecionar)
    }

    if (!isJourneyActive(journey)) {
      showToast('No hay jornada activa. Serás redirigido para iniciar una nueva jornada.', 'error')
      navigate(paths.journey.input)
    }
  }, [journey, navigate])

  return (
    <PageContainer type="authenticated">
      <div className={styles.container}>
        <div className={styles.buttonsContainer}>
          <Button
            variant="outlined"
            onClick={handleNewSale}
            className={
              hoveredButton === 'startSale' ? styles.blackButton : styles.button
            }
            onMouseEnter={() => setHoveredButton('startSale')}
            onMouseLeave={() => setHoveredButton(null)}
          >
            {texts.startSale}
          </Button>

          <Button
            variant="outlined"
            className={
              hoveredButton === 'dailySales'
                ? styles.blackButton
                : styles.button
            }
            onMouseEnter={() => setHoveredButton('dailySales')}
            onMouseLeave={() => setHoveredButton(null)}
            onClick={() => {
              setHoveredButton('dailySales')
              handleDailySales()
            }}
          >
            {texts.dailySales}
          </Button>

          <Button
            variant="outlined"
            className={
              hoveredButton === 'previousClosings'
                ? styles.blackButton
                : styles.button
            }
            onMouseEnter={() => setHoveredButton('previousClosings')}
            onMouseLeave={() => setHoveredButton(null)}
            onClick={() => {
              setHoveredButton('previousClosings')
              handlePreviousClosings()
            }}
          >
            {texts.previousClosings}
          </Button>
        </div>

        <Button
          className={styles.finishButton}
          onClick={() => navigate(paths.journey.finish)}
        >
          {texts.finishDay}
        </Button>
      </div>
    </PageContainer>
  )
}
